export interface CompanyShowcaseProduct {
  id: string;
  name: string;
  price: number;
}

export interface CompanyShowcaseData {
  amenities: string[];
  paymentMethods: string[];
  products: CompanyShowcaseProduct[];
}

export const companyShowcaseBySlug: Record<string, CompanyShowcaseData> = {
  'espaco-central': {
    amenities: ['Wi-Fi', 'Estacionamento', 'Acessibilidade'],
    paymentMethods: ['Pix', 'Cartão de crédito', 'Cartão de débito', 'Dinheiro'],
    products: [
      {
        id: 'gel-finalizador',
        name: 'Gel finalizador',
        price: 24.9,
      },
      {
        id: 'pomada-modeladora',
        name: 'Pomada modeladora',
        price: 39.9,
      },
    ],
  },
};
